import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {  API_URL_PARTICULARIDADES } from 'src/app/app.constants';

@Injectable({
  providedIn: 'root'
})
export class AdicionalesDataService {

apiAdicionales = `${API_URL_PARTICULARIDADES}/adicionales`

  constructor(private http: HttpClient) { }
  
  public  getAllAdicionalesDeLocalidad(pIdLocalidad) {
	return this.http.get<any>(`${this.apiAdicionales}/localidad/${pIdLocalidad}`);
	}
	
}
